import ReactDOM from 'react-dom'

const SnackbarPortal = ({ children }) => {
  let root = document.getElementById('snackbar-root')

  if (!root) {
    root = document.createElement('div')
    root.setAttribute('id', 'snackbar-root')
    document.body.appendChild(root)
  }

  return ReactDOM.createPortal(children, root)
}

export default SnackbarPortal
